// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Krzysztof Ustowski <krzysztof.ustowski@movecloser.pl>
 */
export var FileType;
(function (FileType) {
    FileType["Attachment"] = "attachment";
    FileType["Document"] = "document";
    FileType["Image"] = "image";
    FileType["Video"] = "video";
})(FileType || (FileType = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Piotr Niewczas <piotr.niewczas@movecloser.pl>
 * @author Krzysztof Ustowski <krzysztof.ustowski@movecloser.pl>
 */
export var ImageFilePreset;
(function (ImageFilePreset) {
    ImageFilePreset["List"] = "list";
    ImageFilePreset["Logo"] = "logo";
    ImageFilePreset["Thumbnail"] = "thumbnail";
    ImageFilePreset["Variants"] = "variants";
})(ImageFilePreset || (ImageFilePreset = {}));
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var ImageRatio;
(function (ImageRatio) {
    ImageRatio["HeroMobile"] = "hero_mobile";
    ImageRatio["HeroDesktop"] = "hero_desktop";
    ImageRatio["Standard169"] = "standard_16_9";
    ImageRatio["Standard43"] = "standard_4_3";
    ImageRatio["Original"] = "original";
    ImageRatio["Portrait"] = "portrait";
    ImageRatio["Square"] = "square";
    ImageRatio["Tile"] = "tile";
    ImageRatio["Wide"] = "wide";
})(ImageRatio || (ImageRatio = {}));
/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 *
 * Note!: This map is only for informational purposes. Finale size of images if given rations are determines in API
 */
export const ImageRatioSizes = {
    [ImageRatio.Standard43]: [[1920, 1440], [1440, 1080], [1024, 768], [800, 600], [640, 480], [320, 240]],
    [ImageRatio.Standard169]: [[1920, 1080], [1440, 810], [1024, 576], [800, 450], [640, 360], [320, 180]],
    [ImageRatio.HeroDesktop]: [[1440, 520]],
    [ImageRatio.HeroMobile]: [[375, 540]],
    [ImageRatio.Original]: [],
    [ImageRatio.Portrait]: [[1280, 1920], [640, 960]],
    [ImageRatio.Square]: [[1100, 1100], [500, 500], [100, 100]],
    [ImageRatio.Tile]: [[580, 460], [380, 300], [280, 220], [90, 70]],
    [ImageRatio.Wide]: [[1920, 768], [1024, 409], [800, 300]]
};
